import "./App.css";
import AboutUs from "./pages/AboutUs";
import Home from "./pages/home";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import PlansAndPricing from "./pages/PlansAndPricing";
import ContactUs from "./pages/Contact";
import SupportedPairs from "./pages/SupportedPairs";
import Documentation from "./pages/Documentation";
import ApiPlayground from "./pages/ApiPlayground";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./components/dashboard/Dashboard";
import AdminDashboard from "./components/adminDashboard/AdminDashboard";
import { useAuthCheck } from "./hooks/useAuthCheck";
import useAutoLogout from "./hooks/useAutoLogout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckEmail from "./pages/CheckEmail";
import VerifyEmail from "./pages/VerifyEmail";
import RequestPasswordReset from "./pages/RequestPasswordReset";
import VerifyResetCode from "./pages/VerifyResetCode";
import ResetPassword from "./pages/ResetPassword";
import PricingPolicy from "./pages/PricingPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CancellationRefundPolicy from "./pages/CancellationRefundPolicy";
import SaveToRedis from "./components/SavetoRedis";
import ForexData from "./components/ForexData";
import Snapshot from "./components/Snapshot";
import PreviousClose from "./components/PreviousClose";
import Aggregate from "./components/Aggregate";

function App() {
  useAutoLogout();
  const isLoading = useAuthCheck();

  if (isLoading) {
    return <div>Loading...</div>; // Or your loading component
  }

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route
          path="/request-password-reset"
          element={<RequestPasswordReset />}
        />
        <Route path="/verify-reset-code" element={<VerifyResetCode />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="aboutus" element={<AboutUs />} />
          <Route path="plans&pricing" element={<PlansAndPricing />} />
          {/* <Route path='blog' element={<Blog />} /> */}
          {/* <Route path='blog/:id' element={<BlogDetailPage />} /> */}
          {/* <Route path='blogdetail/:id' element={<BlogDetailPage />} /> */}
          <Route path="contact" element={<ContactUs />} />
          <Route path="supported-pairs" element={<SupportedPairs />} />
          <Route path="documentation" element={<Documentation />} />
          <Route path="api-playground" element={<ApiPlayground />} />
          <Route path="pricing-policy" element={<PricingPolicy />} />
          <Route path="shipping-policy" element={<ShippingPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="cancellation-refund-policy"
            element={<CancellationRefundPolicy />}
          />
        </Route>
        <Route
          path="dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/savetoRedis" element={<SaveToRedis />} />
        <Route path="/forex" element={<ForexData />} />
        <Route
          path="/snapshot"
          element={
            <ProtectedRoute>
              <Snapshot />
            </ProtectedRoute>
          }
        />
        <Route path="/previous-close" element={<PreviousClose />} />
        <Route path="/aggregate" element={<Aggregate />} />
        <Route path="admin-dashboard/*" element={<AdminDashboard />} />
      </Routes>
    </>
  );
}

export default App;
